<!-- Reset Confirmation Modal -->
<div class="modal fade" id="reset-confirmation-modal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-lg">
      <div class="modal-header rounded-lg">
        <h5 class="modal-title"></h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true"><i class="fal fa-times"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <p>Are you sure you want to reset invoice status?</p>
        Reseting will apply to all current jobs and cannot be undone.
        <div class="modal-body__buttons">
          <button type="button" class="btn btn-primary" (click)="reset()" data-dismiss="modal">Reset</button>
          <button type="button" class="btn btn-outline-primary" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- Reset Confirmation Modal End-->
